import useSWR from "swr";
import { type DocumentSummary } from "~/api/types";
import { simpleFetcher } from "~/api/fetcher";

const url = "/api/v2/documents";

interface Options {
  includeArchived: boolean;
}

export function useDocuments(options?: Options) {
  const fetchUrl =
    options === undefined
      ? url
      : `${url}?includeArchived=${options.includeArchived}`;
  return useSWR<DocumentSummary[], Error>(fetchUrl, simpleFetcher);
}
